/**
 * Address lookup accessor for the property combobox.
 *
 * `queryPlaces` polls `GET /api/places`, which proxies whichever geocoding
 * provider the server is configured with. Kept as a thin, injectable wrapper so
 * `PropertyAddressField` stays presentational and can be driven from a stub.
 */

import { getPlaces } from "../../../lib/api";
import type { PlaceSuggestion } from "../types";

/** Searches addresses for the autocomplete query. Short queries return nothing. */
export async function queryPlaces(query: string): Promise<PlaceSuggestion[]> {
  if (query.trim().length < 3) return [];
  const body = await getPlaces(query);
  return body.places;
}
